import { ContactInitSettingModalComponent } from './contact-init-setting-modal.component';
import { CommonModule } from '@angular/common';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { CollapseModule } from 'ngx-bootstrap';
import { LabelModule, LoginResourceService, OrganizationComboBoxModule } from '@blcloud/bl-ng-share-module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  ContactInitDisplaySettingResource,
  ContactExecuteItemResource,
  ContactDivSettingResource,
  ContactListDispResource,
  ContactListExtractProgressResource,
  OrganizationInformationResource,
  LabelResource,
  ExportConditionInfoResource,
  ContactResource,
  ContactStatusBgColorSettingResource,
  ContactLostReasonResource,
  ContactItemResource,
  ContactExecuteResultResource,
  BulkProcessResultResource,
  VehicleInfoResource,
  VehicleItemDispNameSettingResource,
} from '@blcloud/bl-ng-resource';
import { ContactPageModule } from '../../shared/contact/contact-page.module';
import { OrgMasterSelectSearchModule } from '../../page/contact-list-page/org-master-select-search/org-master-select-search.module';
import { ContactListPageService } from '../../page/contact-list-page/contact-list-page.service';
import { BlDialogService } from '@blcloud/bl-ng-ui-component';
import { DivisionResourceService } from '@blcloud/bl-ng-share-module';

@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    CollapseModule,
    OrganizationComboBoxModule.forRoot(),
    LabelModule,
    ContactPageModule,
    OrgMasterSelectSearchModule,
  ],
  exports: [
    ContactInitSettingModalComponent,
  ],
  declarations: [
    ContactInitSettingModalComponent,
  ],
  entryComponents: [
    ContactInitSettingModalComponent,
  ],
  providers: [
    ContactInitDisplaySettingResource,
    ContactExecuteItemResource,
    ContactDivSettingResource,
    LoginResourceService,
    ContactListPageService,
    ContactListDispResource,
    ContactListExtractProgressResource,
    OrganizationInformationResource,
    LabelResource,
    ExportConditionInfoResource,
    ContactResource,
    ContactStatusBgColorSettingResource,
    ContactLostReasonResource,
    ContactItemResource,
    ContactExecuteResultResource,
    BulkProcessResultResource,
    VehicleInfoResource,
    VehicleItemDispNameSettingResource,
    BlDialogService,
    DivisionResourceService,
  ]
})
export class ContactInitSettingModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ContactInitSettingModalModule,
      providers: [
        CollapseModule.forRoot().providers,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/contact-init-setting/contact-init-setting-modal.module.ts